import { useCategoryOptionColorsResolver } from '@/features/colors/hooks/useCategoryOptionColorsResolver';
import type { PageExperience } from '@/features/experiences/types';
import { Box, Button, Icon, forwardRef } from '@/ui';

type Props = {
  category: PageExperience['categories'][number];
  isSelected: boolean;
  onToggle: (categoryId: string) => void;
};

export const CategoryFilterRow = forwardRef(
  ({ category, isSelected, onToggle }: Props, ref) => {
    const resolveOptionColors = useCategoryOptionColorsResolver();
    const { backgroundColor, hoverBackgroundColor, textColor } =
      resolveOptionColors(category.colorName);

    return (
      <Button
        _hover={{ bg: hoverBackgroundColor }}
        alignItems="center"
        bg={backgroundColor}
        borderRadius="ah-md"
        color={textColor}
        display="flex"
        fontSize="sm"
        fontWeight="medium"
        h="auto"
        lineHeight="normal"
        pl="3"
        pr="3"
        py="2.5"
        ref={ref}
        variant="unstyled"
        w="100%"
        _focusVisible={{
          boxShadow: 'none',
          outline: '2px solid',
          outlineColor: 'magicPurple.300',
          outlineOffset: '1px',
        }}
        onClick={() => onToggle(category.id)}
      >
        <Box flex="1" textAlign="left">
          {category.text || <>&nbsp;</>}
        </Box>
        {isSelected && <Icon icon="Checkmark" size={4} />}
      </Button>
    );
  }
);
